
import { mapGetters } from 'vuex';
import WCAddToListButtonMobile from '@/modules/lists/components/WCAddToListButtonMobile/WCAddToListButtonMobile.vue';
import WCProductNameMobile from '@/components/WCProductDetailsMobile/WCProductNameMobile.vue';
import WCProductDetailsMobile from '@/components/WCProductDetailsMobile/WCProductDetailsMobile.vue';
import WCCarousel from '@/components/WCCarousel/WCCarousel.vue';
import WCProductPricing from '@/components/WCProductPricing/WCProductPricing.vue';
import WCImageWithShadow from '@/components/WCImageWithShadow/WCImageWithShadow.vue';
import WCProductDetailsImage from '@/modules/lists/components/WCProductDetailsImage/WCProductDetailsImage.vue';
import ProductImageInfoMixin from '@/mixins/ProductImageInfoMixin';
import CartControlsMixin from '@/modules/cart/mixins/CartControls/CartControls';
import WCBasicAddToCartButton from '@/modules/cart/components/WCBasicAddToCartButton/WCBasicAddToCartButton.vue';
import WCAlternateItems from '@/components/WCAlternateItems/WCAlternateItems.vue';
import { PROMO_RIBBON_TYPE } from '@/constants/PromoRibbonConstants';
import WCPromoRibbon from '@/components/WCPromoRibbon/WCPromoRibbon.vue';
import OrderTypesMixin from '@/modules/orderTypes/mixins/OrderTypesMixin';
import HidePricingMixin from '@/mixins/HidePricingMixin';
import { defineComponent } from 'vue';
import WCMobileSubpageHeader from '@/components/WCMobileSubpageHeader/WCMobileSubpageHeader.vue';
import { PlatformMixin } from '@/modules/platform';
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import ProductDetailMixin from './mixins/ProductDetailMixin';
import WCRestrictedItemRibbon from '../ScanProduct/components/WCRestrictedItemRibbon/WCRestrictedItemRibbon.vue';

export default defineComponent({
  props: {
    item: {
      type: Object,
      required: true,
    },
    itemNotInList: {
      type: Boolean,
      default: false,
    },
    scanMode: {
      type: Boolean,
      required: false,
      default: false,
    },
    priceEmbeddedLineItem: {
      type: Object,
      required: false,
    },
  },
  emits: ['handleProductView'],
  components: {
    WCProductNameMobile,
    WCAddToListButtonMobile,
    WCProductDetailsMobile,
    WCCarousel,
    WCImageWithShadow,
    WCProductDetailsImage,
    WCProductPricing,
    WCAlternateItems,
    WCBasicAddToCartButton,
    WCPromoRibbon,
    WCRestrictedItemRibbon,
    WCMobileSubpageHeader,
    Splide,
    SplideSlide,
  },
  mixins: [
    CartControlsMixin,
    ProductImageInfoMixin,
    ProductDetailMixin,
    OrderTypesMixin,
    HidePricingMixin,
    PlatformMixin,
  ],
  computed: {
    ...mapGetters({
      isGuest: 'user/isGuest',
      isScanAndGoMode: 'user/isCustomerModeScan',
    }),
    /**
     * Method to get the ribbon type key
     */
    promoRibbonType() {
      return PROMO_RIBBON_TYPE;
    },
    isScanModePDP() {
      return this.$route.query.scan === 'true';
    },
    showAddToCartButton() {
      return !this.isScanAndGoMode || (this.isScanAndGoMode && this.isScanModePDP);
    },
    isScanAddToListButtonEnabled() {
      return this.$configuration.listEnabled;
    },
    isScanAddToCartButtonEnabled() {
      return this.$configuration.cartEnabled;
    },
  },
  methods: {
    itemImageSrc(image) {
      return image ? this.getProductImage(image.id) : this.getDefaultProductImg();
    },
  },
});
